import React from "react";

export type TMicrosoftIconProps = React.SVGAttributes<SVGElement>;

export function MicrosoftIcon({ ...rest }: TMicrosoftIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_2424_5223)">
        <path d="M0 0H32V32H0V0Z" fill="#F3F3F3" />
        <path
          d="M1.39131 1.39136H15.3044V15.3044H1.39131V1.39136Z"
          fill="#F35325"
        />
        <path
          d="M16.6956 1.39136H30.6087V15.3044H16.6956V1.39136Z"
          fill="#81BC06"
        />
        <path
          d="M1.39131 16.6957H15.3044V30.6087H1.39131V16.6957Z"
          fill="#05A6F0"
        />
        <path
          d="M16.6956 16.6957H30.6087V30.6087H16.6956V16.6957Z"
          fill="#FFBA08"
        />
      </g>
      <defs>
        <clipPath id="clip0_2424_5223">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
